import { mapActions } from 'vuex'
import { UPDATE_LONGEST_SCROLL } from '../../store/action-types'
import { debounce } from 'lodash'

const SCROLL_EVENT_NAME = 'scroll'
const DEBOUNCE_SCROLL_EVENT_LISTENER_TIME_IN_MILLIS = 450

export default {
  name: 'ScrollTracker',
  computed: {
    scrollListener () {
      return debounce(
        this.reactToScroll.bind(this),
        DEBOUNCE_SCROLL_EVENT_LISTENER_TIME_IN_MILLIS
      )
    }
  },
  mounted () {
    window.addEventListener(SCROLL_EVENT_NAME, this.scrollListener)
  },
  destroyed () {
    window.removeEventListener(SCROLL_EVENT_NAME, this.scrollListener)
  },
  methods: {
    reactToScroll () {
      this.updateLongestScroll(window.pageYOffset)
    },
    ...mapActions({
      updateLongestScroll: UPDATE_LONGEST_SCROLL
    })
  },
  render () {
    return this.$scopedSlots.default({})
  }
}
